module.exports = __webpack_public_path__ + "static/media/spid-logo~zJjEzXFQ.b5234f51.svg";